/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const DeleteUserBudgetQueryParamOwner = {
  Cluster: "cluster",
  Org: "org",
} as const;
export type DeleteUserBudgetQueryParamOwner = ClosedEnum<
  typeof DeleteUserBudgetQueryParamOwner
>;

export type DeleteUserBudgetRequest = {
  id: string;
  owner: DeleteUserBudgetQueryParamOwner;
  orgId?: string | undefined;
};

export const DeleteUserBudgetScope = {
  Org: "org",
  Apikey: "apikey",
  User: "user",
  Team: "team",
  ExternalUser: "external_user",
  UserDefault: "user_default",
  TeamDefault: "team_default",
  ExternalUserDefault: "external_user_default",
} as const;
export type DeleteUserBudgetScope = ClosedEnum<typeof DeleteUserBudgetScope>;

export const DeleteUserBudgetOwner = {
  Cluster: "cluster",
  Org: "org",
} as const;
export type DeleteUserBudgetOwner = ClosedEnum<typeof DeleteUserBudgetOwner>;

/**
 * OK
 */
export type DeleteUserBudgetResponseBody = {
  scope: DeleteUserBudgetScope;
  scopeId: string;
  owner: DeleteUserBudgetOwner;
  deleted: true;
};

/** @internal */
export const DeleteUserBudgetQueryParamOwner$inboundSchema: z.ZodNativeEnum<
  typeof DeleteUserBudgetQueryParamOwner
> = z.nativeEnum(DeleteUserBudgetQueryParamOwner);
/** @internal */
export const DeleteUserBudgetQueryParamOwner$outboundSchema: z.ZodNativeEnum<
  typeof DeleteUserBudgetQueryParamOwner
> = DeleteUserBudgetQueryParamOwner$inboundSchema;

/** @internal */
export const DeleteUserBudgetRequest$inboundSchema: z.ZodType<
  DeleteUserBudgetRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  owner: DeleteUserBudgetQueryParamOwner$inboundSchema,
  org_id: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "org_id": "orgId",
  });
});
/** @internal */
export type DeleteUserBudgetRequest$Outbound = {
  id: string;
  owner: string;
  org_id?: string | undefined;
};

/** @internal */
export const DeleteUserBudgetRequest$outboundSchema: z.ZodType<
  DeleteUserBudgetRequest$Outbound,
  z.ZodTypeDef,
  DeleteUserBudgetRequest
> = z.object({
  id: z.string(),
  owner: DeleteUserBudgetQueryParamOwner$outboundSchema,
  orgId: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    orgId: "org_id",
  });
});

export function deleteUserBudgetRequestToJSON(
  deleteUserBudgetRequest: DeleteUserBudgetRequest,
): string {
  return JSON.stringify(
    DeleteUserBudgetRequest$outboundSchema.parse(deleteUserBudgetRequest),
  );
}
export function deleteUserBudgetRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteUserBudgetRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteUserBudgetRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteUserBudgetRequest' from JSON`,
  );
}

/** @internal */
export const DeleteUserBudgetScope$inboundSchema: z.ZodNativeEnum<
  typeof DeleteUserBudgetScope
> = z.nativeEnum(DeleteUserBudgetScope);
/** @internal */
export const DeleteUserBudgetScope$outboundSchema: z.ZodNativeEnum<
  typeof DeleteUserBudgetScope
> = DeleteUserBudgetScope$inboundSchema;

/** @internal */
export const DeleteUserBudgetOwner$inboundSchema: z.ZodNativeEnum<
  typeof DeleteUserBudgetOwner
> = z.nativeEnum(DeleteUserBudgetOwner);
/** @internal */
export const DeleteUserBudgetOwner$outboundSchema: z.ZodNativeEnum<
  typeof DeleteUserBudgetOwner
> = DeleteUserBudgetOwner$inboundSchema;

/** @internal */
export const DeleteUserBudgetResponseBody$inboundSchema: z.ZodType<
  DeleteUserBudgetResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  scope: DeleteUserBudgetScope$inboundSchema,
  scope_id: z.string(),
  owner: DeleteUserBudgetOwner$inboundSchema,
  deleted: z.literal(true),
}).transform((v) => {
  return remap$(v, {
    "scope_id": "scopeId",
  });
});
/** @internal */
export type DeleteUserBudgetResponseBody$Outbound = {
  scope: string;
  scope_id: string;
  owner: string;
  deleted: true;
};

/** @internal */
export const DeleteUserBudgetResponseBody$outboundSchema: z.ZodType<
  DeleteUserBudgetResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteUserBudgetResponseBody
> = z.object({
  scope: DeleteUserBudgetScope$outboundSchema,
  scopeId: z.string(),
  owner: DeleteUserBudgetOwner$outboundSchema,
  deleted: z.literal(true),
}).transform((v) => {
  return remap$(v, {
    scopeId: "scope_id",
  });
});

export function deleteUserBudgetResponseBodyToJSON(
  deleteUserBudgetResponseBody: DeleteUserBudgetResponseBody,
): string {
  return JSON.stringify(
    DeleteUserBudgetResponseBody$outboundSchema.parse(
      deleteUserBudgetResponseBody,
    ),
  );
}
export function deleteUserBudgetResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<DeleteUserBudgetResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteUserBudgetResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteUserBudgetResponseBody' from JSON`,
  );
}
